import AuthService from '/@/modules/auth/services/AuthService';
import NotificationService from '/@/modules/core/ui/services/NotificationService';

export const ResendEmailVerificationMixin = {
  static: {
    shouldShowEmailSentNotification: true
  },
  data() {
    return {
      isSendingMail: false,
      isMailSent: false
    };
  },
  methods: {
    async resendVerificationMail() {
      try {
        this.isSendingMail = true;
        const data = await AuthService.sendVerifyEmailLink();
        if (this.shouldShowEmailSentNotification) {
          NotificationService.show(data);
        }
        this.isMailSent = true;
      } finally {
        this.isSendingMail = false;
      }
    }
  }
};
